import React from 'react';
import { IconRocket, IconTarget, IconUserTie, IconBox, IconPhone, IconBrain, IconBolt, IconChartLine, IconCheck } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import Button from './Button';
import useScrollReveal from '../hooks/useScrollReveal';
import './PPCSection.css';

const PPCSection = () => {
  const { t } = useLanguage();
  const features = [
    { icon: 'partner', title: t.ppcSection.feature1Title, text: t.ppcSection.feature1Text },
    { icon: 'seller', title: t.ppcSection.feature2Title, text: t.ppcSection.feature2Text },
    { icon: 'communication', title: t.ppcSection.feature3Title, text: t.ppcSection.feature3Text },
    { icon: 'manual', title: t.ppcSection.feature4Title, text: t.ppcSection.feature4Text },
    { icon: 'innovation', title: t.ppcSection.feature5Title, text: t.ppcSection.feature5Text },
    { icon: 'profit', title: t.ppcSection.feature6Title, text: t.ppcSection.feature6Text },
  ];

  const getFeatureIcon = (iconType) => {
    switch(iconType) {
      case 'partner': return <IconUserTie size={20} />;
      case 'seller': return <IconBox size={20} />;
      case 'communication': return <IconPhone size={20} />;
      case 'manual': return <IconBrain size={20} />;
      case 'innovation': return <IconBolt size={20} />;
      case 'profit': return <IconChartLine size={20} />;
      default: return <IconTarget size={20} />;
    }
  };

  const textReveal = useScrollReveal({ threshold: 0.1 });
  const visualReveal = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="ppc-section-fox" id="ppc">
      <div className="ppc-section-fox__bg-orb ppc-section-fox__bg-orb--1"></div>
      <div className="ppc-section-fox__bg-orb ppc-section-fox__bg-orb--2"></div>
      <div className="ppc-section-fox__bg-orb ppc-section-fox__bg-orb--3"></div>
      <div className="ppc-section-fox__bg-grid"></div>
      
      <div className="ppc-section-fox__container">
        <div className="ppc-section-fox__content">
          <div ref={textReveal.ref} className={`ppc-section-fox__text-content reveal--left ${textReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="ppc-section-fox__label">
              <IconRocket size={22} />
              {t.ppcSection.label}
            </div>
            <h2 className="ppc-section-fox__title">
              {t.ppcSection.title} <span className="ppc-section-fox__title-gradient">{t.ppcSection.titleHighlight}</span>
            </h2>
            <p className="ppc-section-fox__tagline">{t.ppcSection.tagline}</p>
            <p className="ppc-section-fox__description">
              {t.ppcSection.description} <strong>{t.ppcSection.descriptionBold}</strong>{t.ppcSection.descriptionEnd}
            </p>
            
            <div className="ppc-section-fox__features">
              {features.map((feature, index) => (
                <div key={index} className="ppc-section-fox__feature">
                  <span className="ppc-section-fox__feature-icon">{getFeatureIcon(feature.icon)}</span>
                  <div className="ppc-section-fox__feature-content">
                    <span className="ppc-section-fox__feature-title">{feature.title}</span>
                    <span className="ppc-section-fox__feature-text">{feature.text}</span>
                  </div>
                </div>
              ))}
            </div>

            <Button href="https://meetings-eu1.hubspot.com/michael-wenger?uuid=9cf1d252-81d9-4d0a-ac62-21972be61c70">
              {t.ppcSection.cta}
            </Button>
          </div>

          <div ref={visualReveal.ref} className={`ppc-section-fox__visual reveal--right ${visualReveal.isRevealed ? 'reveal--visible' : ''}`}>
            <div className="ppc-section-fox__card-stack">
              <div className="ppc-section-fox__stat-card ppc-section-fox__stat-card--1">
                <div className="ppc-section-fox__stat-icon"><IconCheck size={22} /></div>
                <div className="ppc-section-fox__stat-content">
                  <span className="ppc-section-fox__stat-label">{t.ppcSection.stat1Label}</span>
                  <span className="ppc-section-fox__stat-value">{t.ppcSection.stat1Value}</span>
                </div>
              </div>
              <div className="ppc-section-fox__stat-card ppc-section-fox__stat-card--2">
                <div className="ppc-section-fox__stat-icon"><IconCheck size={22} /></div>
                <div className="ppc-section-fox__stat-content">
                  <span className="ppc-section-fox__stat-label">{t.ppcSection.stat2Label}</span>
                  <span className="ppc-section-fox__stat-value">{t.ppcSection.stat2Value}</span>
                </div>
              </div>
              <div className="ppc-section-fox__stat-card ppc-section-fox__stat-card--3">
                <div className="ppc-section-fox__stat-icon"><IconCheck size={22} /></div>
                <div className="ppc-section-fox__stat-content">
                  <span className="ppc-section-fox__stat-label">{t.ppcSection.stat3Label}</span>
                  <span className="ppc-section-fox__stat-value">{t.ppcSection.stat3Value}</span>
                </div>
              </div>
            </div>
            <div className="ppc-section-fox__glow"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPCSection;
